import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {Modal, Table, Loader} from 'semantic-ui-react';

class BinPendingModal extends Component {
  fetchData() {
    const {code} = this.props;
    this.props.fetchBinningPendingDetail(code);
  }

  renderItems() {
    const {binPendingData} = this.props;

    if (!binPendingData.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={4}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return binPendingData.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.invoice}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.box}</Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row active>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }
  
  render() {
    const {quantity, binPendingData} = this.props;

    if (!quantity) {
      return <div>{quantity}</div>;
    }
    return (
      <Modal size={'small'} onOpen={() => this.fetchData()}
        trigger={<div className='link'>
          {quantity}
        </div>} closeIcon>

        <Modal.Header>
          Binning
          <span className='quantity-container'>
            {_.sumBy(binPendingData, 'quantity')}
          </span>
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>

            <Table striped className='toyota-grid'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Número de Caja</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
          
              <Table.Body>
                {this.renderData()}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingBinningPendingDetail,
    'binPendingData': state.partModals.binningPendingDetail,
  };
};

const {
  fetchBinningPendingDetail,
} = Actions;

export default connect(mapStateToProps, {
  fetchBinningPendingDetail,
})(BinPendingModal);
